import React, { createContext, useContext } from 'react';

interface IdContextProps {
  children: React.ReactNode;
  id: string;
}

export const useWidgetId = () => useContext(IdContext);

export const IdContext = createContext('');

const IdProvider = ({ children, id }: IdContextProps) => {
  return <IdContext.Provider value={id}>{children}</IdContext.Provider>;
};

export default IdProvider;
